<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

        <CounterpartyComponent/>

    </transition>
  </div>
</template>

<script>

import CounterpartyComponent from '@/components/counterparties/CounterpartyComponent.vue'

export default {
  name: 'Counterparty',
  components: {
    CounterpartyComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>
